module.exports = __webpack_public_path__ + "media/huaxiang.6dcd7767.mp4";